import { render, staticRenderFns } from "./WishlistAction.vue?vue&type=template&id=421a50a1&"
import script from "./WishlistAction.vue?vue&type=script&lang=js&"
export * from "./WishlistAction.vue?vue&type=script&lang=js&"
import style0 from "./WishlistAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports